<form #form="ngForm" (ngSubmit)="consider()">
  <div class="card mb-4">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md">
          <label class="col-form-label col-auto">
            <i class="bi bi-info-circle ms-2 me-2"></i>
            <strong>รายละเอียดผู้บันทึกข้อมูล/หน่วยงานบันทึกข้อมูล</strong>
          </label>
        </div>
        <div class="col-md text-end">
          <a class="btn btn-outline-secondary float-right" role="button" (click)="back()">
            <i class="bi bi-chevron-left me-2"></i>กลับไปหน้าค้นหา
          </a>
        </div>
      </div>
      <hr>
      <div class="row mt-3 mb-3">
        <div class="col-md">
          <div class="form-group row">
            <label for="ermRegMain.id" class="col-lg-4 col-form-label">เลขที่คำร้อง</label>
            <div class="col-lg-8">
              <input type="text" class="form-control"
                     id="ermRegMain.id"
                     name="ermRegMain.id"
                     [ngModel]="ermRegMain.id || '-'"
                     disabled>
            </div>
          </div>
        </div>
        <div class="col-md">
          <div class="form-group row">
            <label for="effectiveDate" class="col-lg-4 col-form-label">วันที่เริ่มใช้หน่วยบริการ</label>
            <div class="col-lg-8">
              <input type="text" class="form-control"
                     id="effectiveDate"
                     name="effectiveDate"
                     [ngModel]="(ermRegMain.effectiveDate | thaidatetime) || '-'"
                     disabled>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 mb-3">
        <div class="col-md">
          <div class="form-group row">
            <label for="createPerson" class="col-lg-4 col-form-label">ผู้บันทึกข้อมูล</label>
            <div class="col-lg-8">
              <input type="text" class="form-control"
                     id="createPerson"
                     name="createPerson"
                     [ngModel]="ermRegMain.createPerson?.fullNameWithoutTitle"
                     disabled>
            </div>
          </div>
        </div>
        <div class="col-md">
          <div class="form-group row">
            <label for="createHospital" class="col-lg-4 col-form-label">หน่วยงานบันทึกข้อมูล</label>
            <div class="col-lg-8">
              <input type="text"
                     class="form-control"
                     id="createHospital"
                     name="createHospital"
                     [ngModel]="(ermRegMain.createHospital?.hcodeAndHnameForReport || ermRegMain.createHcode) || '-'"
                     disabled>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 mb-3">
        <div class="col-md">
          <div class="form-group row">
            <label for="registerSource" class="col-lg-4 col-form-label">แหล่งข้อมูล</label>
            <div class="col-lg-8">
              <input type="text" class="form-control"
                     id="registerSource"
                     name="registerSource"
                     [ngModel]="ermRegMain.registerSource || '-'"
                     disabled>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <!--            todo-->
            <label for="input7" class="col-lg-4 col-form-label">เจ้าหน้าที่ผู้รับผิดชอบ</label>
            <div class="col-lg-8">
              <input type="text" class="form-control" id="input7" name="input7" value="-" disabled>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="card mb-4">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md">
          <label class="col-form-label col-auto">
            <i class="bi bi-person-vcard-fill ms-2 me-2"></i>
            <strong>รายละเอียดผู้ขอลงทะเบียน</strong>
          </label>
        </div>
      </div>
      <hr>
      <div class="row mt-3 mb-3">
        <div class="col-md">
          <div class="form-group row">
            <label for="pid" class="col-lg-2 col-form-label">เลขประจำตัวประชาชน(ผู้ขอลงทะเบียน)</label>
            <div class="col-lg-4">
              <input type="text"
                     class="form-control"
                     id="pid"
                     name="pid"
                     [ngModel]="ermRegMain.personalData.personalId || '-'"
                     disabled>
            </div>

            <label for="fname" class="col-lg-2 col-form-label">ชื่อ-นามสกุล(ผู้ขอลงทะเบียน)</label>
            <div class="col-lg-4">
              <input type="text" class="form-control" id="fname" name="fname"
                     [ngModel]="ermRegMain.personalData?.fullNameWithoutTitle || '-'"
                     disabled>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 mb-3">
        <div class="col-md">
          <div class="form-group row">
            <label for="input10" class="col-lg-2 col-form-label">ประเภทการยื่นคำร้อง</label>
            <div class="col-lg-4">
              <input type="text" class="form-control" id="input10" name="input10"
                     [ngModel]="pettitionType[ermRegMain?.ermRegDoc?.pettitionType] || '-'"
                     disabled>
            </div>

            <label for="address.tel" class="col-lg-2 col-form-label">เบอร์โทรผู้ขอลงทะเบียน</label>
            <div class="col-lg-4">
              <input type="text"
                     class="form-control"
                     id="address.tel"
                     name="address.tel"
                     [ngModel]="ermRegMain?.addrTel || '-'"
                     disabled>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 mb-3">
        <div class="col-md">
          <div class="form-group row">
            <label for="addressType" class="col-lg-2 col-form-label">ประเภทการพักอาศัย</label>
            <div class="col-lg-4">
              <input type="text"
                     class="form-control"
                     id="addressType"
                     name="addressType"
                     [ngModel]="addressType[ermRegMain?.ermRegDoc?.addressType] || '-'"
                     disabled>
            </div>

            <label for="pettitionType" class="col-lg-2 col-form-label">ประเภทการลงทะเบียน</label>
            <div class="col-lg-4">
              <input type="text" class="form-control" id="pettitionType" name="pettitionType"
                     [ngModel]="ermRegMain?.ermMasterRegType?.name || '-'"
                     disabled>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 mb-3">
        <div class="col-md">
          <div class="form-group row">
            <label for="cardbase.fullAddress" class="col-lg-2 col-form-label">ที่อยู่ตามทะเบียนบ้าน</label>
            <div class="col-lg-8">
              <input type="text" class="form-control" id="cardbase.fullAddress" name="cardbase.fullAddress"
                     [ngModel]="ermRegMain?.personalData?.homeAddress?.fullAddress || '-'" disabled>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 mb-3">
        <div class="col-md">
          <div class="form-group row">
            <label for="input15" class="col-lg-2 col-form-label">ที่อยู่ปัจจุบัน</label>
            <div class="col-lg-8">
              <input type="text" class="form-control" id="input15" name="input15"
                     [ngModel]=" (ermRegMain?.fullAddress) || '-'" disabled>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row mb-4">
    <div class="col-md">
      <div class="card">
        <div class="card-body bg-primary-subtle">
          <div class="row mb-3">
            <div class="col-md">
              <label class="col-form-label col-auto">
                <i class="bi bi-hospital ms-2 me-2"></i>
                <strong>เครือข่ายหน่วยบริการเดิม</strong>
              </label>
            </div>
          </div>
          <hr>
          <div class="form-group row mb-3 mt-3">
            <label for="oldPurchaseProvince" class="col-lg-3 col-form-label">จังหวัดที่ลงทะเบียน</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="oldPurchaseProvince" name="oldPurchaseProvince"
                     [ngModel]="ermRegMain.oldPurchaseProvince?.name || '-'" disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="oldHsub" class="col-lg-3 col-form-label">หน่วยบริการปฐมภูมิ</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="oldHsub" name="oldHsub"
                     [ngModel]="ermRegMain.oldHsub?.hcodeAndHnameForReport || '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="oldHmainOp" class="col-lg-3 col-form-label">หน่วยบริการประจำ</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="oldHmainOp" name="oldHmainOp"
                     [ngModel]="ermRegMain.oldHmainOp?.hcodeAndHnameForReport || '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="oldHmain" class="col-lg-3 col-form-label">หน่วยบริการที่รับการส่งต่อ</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="oldHmain" name="oldHmain"
                     [ngModel]="ermRegMain.oldHmain?.hcodeAndHnameForReport || '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="rightName" class="col-lg-3 col-form-label">สิทธิหลัก</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="rightName" name="rightName"
                     [ngModel]="ermRegMain.oldPersonalFund?.mainInscl ? ermRegMain.oldPersonalFund?.mainInscl.rightId + ' - ' + ermRegMain.oldPersonalFund?.mainInscl.rightName : '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="insclName" class="col-lg-3 col-form-label">สิทธิย่อย</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="insclName" name="insclName"
                     [ngModel]="ermRegMain.oldPersonalFund?.subInscl ? ermRegMain.oldPersonalFund?.subInscl.inscl + ' - ' + ermRegMain.oldPersonalFund?.subInscl.insclName : '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="old-mastercupId" class="col-lg-3 col-form-label">รหัสเครือข่าย</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="old-mastercupId" name="old-mastercupId"
                     [ngModel]="ermRegMain.oldPersonalFund?.mastercupId || '-'" disabled>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md">
      <div class="card">
        <div class="card-body bg-success-subtle">
          <div class="row mb-3">
            <div class="col-md">
              <label class="col-form-label col-auto">
                <i class="bi bi-hospital ms-2 me-2"></i>
                <strong>เครือข่ายหน่วยบริการสิทธิ ณ ปัจจุบัน</strong>
              </label>
            </div>
          </div>
          <hr>
          <div class="form-group row">
            <label for="regProvince" class="col-lg-3 col-form-label">จังหวัดที่ลงทะเบียน</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="regProvince" name="regProvince"
                     [ngModel]="ermRegMain.regProvince?.name || '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="hsub" class="col-lg-3 col-form-label">หน่วยบริการปฐมภูมิ</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="hsub" name="hsub"
                     [ngModel]="ermRegMain.hsub?.hcodeAndHnameForReport || '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="hmainOp" class="col-lg-3 col-form-label">หน่วยบริการประจำ</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="hmainOp" name="hmainOp"
                     [ngModel]="ermRegMain.hmainOp?.hcodeAndHnameForReport || '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="hmain" class="col-lg-3 col-form-label">หน่วยบริการที่รับการส่งต่อ</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="hmain" name="hmain"
                     [ngModel]="ermRegMain.hmain?.hcodeAndHnameForReport || '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="mainInscl" class="col-lg-3 col-form-label">สิทธิหลัก</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="mainInscl" name="mainInscl"
                     [ngModel]="ermRegMain.mainInscl ? ermRegMain.mainInscl.rightId + ' - ' + ermRegMain.mainInscl.rightName : '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="subInscl" class="col-lg-3 col-form-label">สิทธิย่อย</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="subInscl" name="subInscl"
                     [ngModel]="ermRegMain.subInscl ? ermRegMain.subInscl.inscl + ' - ' + ermRegMain.subInscl.insclName : '-'"
                     disabled>
            </div>
          </div>
          <div class="form-group row mb-3 mt-3">
            <label for="mastercupId" class="col-lg-3 col-form-label">รหัสเครือข่าย</label>
            <div class="col-lg-9">
              <input type="text" class="form-control" id="mastercupId" name="mastercupId"
                     [ngModel]="ermRegMain.mastercupId || '-'"
                     disabled>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-4">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md">
          <label class="col-form-label col-auto">
            <i class="bi bi-file-text ms-2 me-2"></i>
            <strong>เอกสารประกอบพิจารณาการลงทะเบียน</strong>
          </label>
        </div>
        <div class="col-md text-end">
          <button
            *ngIf="considered()"
            (click)="ermRegMain.considerResult.status = 'REVISED_CONSIDERATION'"
            type="button"
            class="btn btn-outline-danger float-right">
            <i class="bi bi-pencil me-1"></i>คลิกเพื่อแก้ไขผลการตรวจสอบ
          </button>
        </div>
      </div>
      <hr>
    </div>
    <table class="table table-responsive-xl mb-0">
      <thead>
      <tr>
        <th nowrap scope="col" class="text-center">ลำดับที่</th>
        <th nowrap scope="col">ประเภทเอกสาร</th>
        <th nowrap scope="col" class="text-center">แสดง/ดาวน์โหลด</th>
      </tr>
      </thead>
      <tbody>
        @for (item of ermRegMain?.considerResult?.documents; let i = $index; track item.id) {
          <tr>
            <th scope="row" class="text-center">{{ i + 1 | number }}</th>
            <td>
              <i class="bi bi-paperclip text-muted me-1"></i>{{ item?.fileGroupName }} <br>
              <div class="form-group d-inline-block mt-1">
                <ng-container *ngIf="canAudit()">
                  <button type="button"
                          class="btn me-1"
                          [ngClass]="{'btn-outline-secondary':item.status!=='Y','btn-success':item.status==='Y'}"
                          (click)="doAudit(item,'Y')">
                    <i class="bi bi-check">&nbsp;</i>
                    ผ่าน
                  </button>
                  <button type="button"
                          class="btn me-1"
                          [ngClass]="{'btn-outline-secondary':item.status!=='N','btn-danger':item.status==='N'}"
                          (click)="doAudit(item,'N')">
                    <i class="bi bi-x">&nbsp;</i>
                    ไม่ผ่าน
                  </button>
                </ng-container>
                <ng-container *ngIf="ermRegMain?.considerResult?.status == 'APPROVED'">
                  <button type="button"
                          class="btn me-1 btn-sm rounded-circle"
                          [ngClass]="{'btn-outline-secondary':item.status!=='Y','btn-success':item.status==='Y'}">
                    <i class="bi bi-check">&nbsp;</i>
                  </button>
                  <button type="button"
                          class="btn me-1 btn-sm rounded-circle"
                          [ngClass]="{'btn-outline-secondary':item.status!=='N','btn-danger':item.status==='N'}">
                    <i class="bi bi-x">&nbsp;</i>
                  </button>
                  <label *ngIf="item.status == 'N'" class="btn btn-secondary btn-sm m-0">
                    {{ item?.reason?.docRefDesc }}
                  </label>
                </ng-container>
                <ng-container *ngIf="item.status==='N' && canAudit() && (attReason[item?.fileGroup] | async)?.length">
                  <select [id]="'file' + i"
                          [name]="'file' + i"
                          [compareWith]="compareWithId"
                          [(ngModel)]="item.reason"
                          class="custom-select mt-1 form-select">
                    <option [ngValue]="undefined">กรุณาเลือกเหตุผล</option>
                    <option [ngValue]="reason"
                            *ngFor="let reason of attReason[item?.fileGroup] | async">{{ reason.docRefDesc }}
                    </option>
                  </select>
                  <gt-error [field]="'considerResult.documents[' + i + '].reason'"></gt-error>
                </ng-container>
              </div>
            </td>
            <td nowrap>
              <button *ngIf="isImage(item?.mimeType)" class="btn btn-light border me-1 rounded-pill btn-sm"
                      type="button" (click)="showImage(item)">
                <i class="bi bi-eye me-2"></i>
                <span class="d-none d-xl-inline-block">แสดง</span>
              </button>
              <button *ngIf="isPdf(item?.mimeType)" class="btn btn-light border me-1 rounded-pill btn-sm" type="button"
                      (click)="showDoc(item)">
                <i class="bi bi-eye me-2"></i>
                <span class="d-none d-xl-inline-block">แสดง</span>
              </button>
              <button class="btn btn-primary rounded-pill btn-sm" type="button" (click)="downloadDoc(item)">
                <i class="bi bi-download me-2"></i>
                <span class="d-none d-xl-inline-block">ดาวน์โหลด</span>
              </button>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="26">
              <app-not-found></app-not-found>
            </td>
          </tr>
        }
      </tbody>
      <tfoot>
      <tr>
        <td colspan="3">
          <ng-container *ngIf="canAudit()">
            <div *ngIf="ermRegMain?.considerResult?.documents?.length" class="mb-4 text-right">
              <button type="submit"
                      class="btn me-1"
                      [ngClass]="{'btn-success':enableSave(),'btn-secondary':!enableSave()}"
                      [disabled]="!enableSave()">
                <i class="bi bi-check-square"></i>
                บันทึก
              </button>
              <button type="reset" class="btn btn-default border bg-white" (click)="reset()">
                ยกเลิก
              </button>
            </div>
          </ng-container>
        </td>
      </tr>
      </tfoot>
    </table>
  </div>
</form>
